import { REPRESENTATION } from '../root/constants'
import * as actions from './actions'

const initState = {
    devicesView: REPRESENTATION.assigned
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.SET_DEVICE_VIEW:
            return {
                ...state,
                ...{
                    devicesView: action.view
                }
            }
        default:
            return state
    }
}
